class Account {
	static NEW = 0;
	static TRIAL = 1;
	static ACTIVE = 2;
	static OVERDUE = 3;
	static CANCELED = 4;
	static PAUSED = 5;
	static SUSPENDED = 6;

	constructor() {
		this._type;
		this._freq;
		this._renewDate;
		this._tariff;
		this._ownerId;

		this._members;
		this._status;
		this._payment;
		this.paymentValid;
		this.paymentRequired;
		this._displayPrefs = {};
		
		this._settings = {};
		this._additions = [];
		this._unchanged = [];
		this._removals = [];
		
		this._route = [];
		this._panes = {};
		this.outputPane = ge('outputPane');
		this.paymentForm = null;
		
		this.nextButton = null;
		this.connectionResults = Dialog.Popup(
			UI.div('container'),
			'below-left'
		);
		
		this.merchantSessionKey = null;
		this.paymentFormInitialised = false;
		this.PaymentSet = false;
		this.showMembersPane = false;
		
		state(this.outputPane, "loading");
		this.getData();
	}

	get type() {
		return typeof this._settings.type == 'undefined' ?  this._type : this._settings.type;
	}
	
	set type(value) {
		this._settings.type = value;
		this.updateTypePane();
	}

	get freq() {
		return this._freq;
	}

	set freq(value) {
		this._freq = value;
		this.updateTypePane();
	}
	
	get isFamily() {
		return this.type == SUBSCRIPTION.FAMILY;
	}

	getData() {
		this._settings = {};
		API.fetch('accounts')
		.then(this.init.bind(this));
	}
	
	init(data) {
		this._panes = {};
		delete this._paymentForm;
		
		this.firstName = data.firstName;
		this.lastName = data.lastName;
		this.email = data.email;
		this.username = data.username;
		
		this._type = data.plan.type;
		this._freq = data.plan.freq;
		this._status = data.plan.status;
		this._tariff = data.plan.tariff;
		this._ownerId = data.plan.ownerId;
		this._members = data.plan.members;

		this.paymentValid = data.paymentValid;
		this.paymentRequired = data.paymentRequired;
		this._statusText = data.planStatus;
		this._payment = data.paymentStatus;

		this._cardholder = data.cardholder;

		this._additions = [];
		this._unchanged = [];
		this._removals = [];
		
		this.activeAllocation = data.activeAllocation;
		this.pendingAllocations = data.pendingAllocations;
		this._displayPrefs = data.displayPrefs || {};
		
		if (this.isFamily && this.showMembersPane && this._members.length == 0) {
			this._route = ['members', 'status'];
		}
		else {
			this._route = ['status'];
		}
		this.showMembersPane = false;
		this.update();
		state(this.outputPane)
	}
	
	back() {
		if (this._route.length > 1) 
			this._route.shift();
		this.update();
	}
	
	goto(pane) {
		this._route.unshift(pane);
		this.update();
	}
	
	update() {
		this.outputPane.innerHTML = '';
		state(this.outputPane, "loading");
		this.getPane();
	}
	
	async getPane() {
		switch(this._route[0]) {
			case 'change-details': return this.getUpdateDetailsPane();
			case 'change-password': return this.getChangePasswordForm();
			case 'display-settings': return this.getDisplaySettingsPane();
			case 'subscription-type': return this.getSubscriptionTypePane();
			case 'payment-form': return this.getPaymentForm();
			case 'billing-address-form': return this.getBillingAddressForm();
			case 'members': return this.getMembersPane();
			case 'confirm-subscription': return this.getConfirmSubscriptionPane();
			case 'cancel-subscription': return this.getCancelPane();
			default: return this.getStatusPane();
		}
	}
	
	getStatusPane() {
		if (!this._panes.hasOwnProperty('status')) {

			let email = this.email == '' ? 
			UI.span('text-neutral-700', _('no email')) :
			UI.span('', this.email);

			let username = this.username == '' ?
			UI.span('text-neutral-700', _('no username set')):
			UI.span('', this.username);

			let rows = [
				UI.htm('h1', 'text-2xl my-4', _('Personal Details')),
				UI.p('', `Name: ${this.firstName} ${this.lastName}`),
				UI.p('', ['Email: ', email]),
				UI.p('', ['Username: ', username]),
				UI.div('flex flex-col items-end gap-2', [
					UI.btn(
						'text-primary-600',
						_('Update Details'),
						{
							'click': () => this.goto('change-details')
						}
					),
					UI.btn(
						'text-primary-600',
						_('Change Password'),
						{
							'click': () => this.goto('change-password')
						}
					),
					UI.btn(
						'text-primary-600',
						_('Display Settings'),
						{
							'click': () => this.goto('display-settings')
						}
					)
				])
			];


			if (this.pendingAllocations.length) {
				rows.push(UI.htm('h3', 'text-2xl mt-4', _("Pending allocations")));

				for (let pending of this.pendingAllocations) {
					rows.push(UI.p(null, [
						span(null, pending.desc),
						UI.btn('text-primary-600 ms-3', _("ACCEPT"), {
							'click': () => this.acceptAllocation(pending.id)
						}),
						UI.btn('text-primary-600 ms-3', _("DECLINE"), {
							'click': () => this.declineAllocation(pending.id)
						})
					]));
				}
			}

			let buttons = [];
			switch (this._status) {
				case Account.TRIAL:
				case Account.ACTIVE:
					buttons.push(
						UI.btn(
							'text-primary-600',
							_("Change Plan"),
							{
								'click': this.goto.bind(this, 'subscription-type')
							}
						)
					);
					break;
				case Account.CANCELED:
				case Account.SUSPENDED:
					buttons.push(
						UI.btn(
							'text-primary-600',
							_("Re-start Plan"),
							{
								'click': this.goto.bind(this, 'subscription-type')
							}
						)
					);
					break;
				case Account.PAUSED:
					buttons.push(
						UI.btn(
							'text-primary-600',
							_("Leave Joint Plan"),
							{
								'click': this.goto.bind(this, 'subscription-type')
							}
						)
					);
					break;
				default:
					buttons.push(
						UI.btn(
							'text-primary-600',
							_("Start New Plan"),
							{
								'click': this.goto.bind(this, 'subscription-type')
							}
						)
					);
			}
			if (
				this._status == Account.ACTIVE ||
				this._status == Account.OVERDUE ||
				this._status == Account.TRIAL
			) {
				buttons.push(btn('text-neutral-700', _("Cancel plan"), {
					'click': this.goto.bind(this, 'cancel-subscription')
				}));
			}

			rows.push(UI.div('my-4', [
				UI.htm('h1', 'text-2xl', _("Payment plan")),
				UI.p(null, this._statusText),
				UI.div('flex flex-col items-end gap-2', buttons)
			]));

			if (this.isFamily) {
				let members = [];
				for (let member of this._members) {
					members.push(UI.p(null, member.name));
				}

				rows.push(UI.div('my-4', [
					UI.htm('h1', 'text-2xl', _("Family Plan Members")),
					UI.div('', members),
					UI.div('flex flex-col items-end gap-2', [
						UI.btn('text-primary-600', _("Change Members"), {
							'click': this.goto.bind(this, 'members')
						})
					])
				]));
			}

			if (this._status) {
				let paymentButtons = [];
				if (this.paymentValid) {
					paymentButtons.push(UI.btn('text-primary-600', _("Change Payment Method"), {
						'click': () => {
							this.goto('payment-form')
						}
					}));
					paymentButtons.push(UI.btn('text-neutral-700', _("Remove payment method"), {
						'click': this.removePayment.bind(this)
					}));
				}
				else {
					paymentButtons.push(UI.btn('text-primary-600', _("Add Payment Method"), {
						'click' : () => {
							this.goto('payment-form')
						}
					}))
				}
				rows.push(UI.div('my-4', [
					UI.htm('h1', 'text-2xl', _("Payment method")),
					UI.div('', [
						UI.p(null, this._payment),
						UI.btn('text-sm text-secondary-700', _("View payment history"), {
							'click': () => window.location.href = 'payments'
						})
					]),
					UI.div('flex flex-col items-end gap-2', paymentButtons)
				]));
			}

			rows.push(
				UI.div('text-xs text-red-800', UI.a(
					_('Delete this account'),
					null,
					{
						'href': '/delete-account'
					}
				))
			);

			this._panes.status = UI.div('', rows);
		}
		this.outputPane.appendChild(this._panes.status);
		state(this.outputPane);
	}
	
	getUpdateDetailsPane() {
		if (!this._panes.hasOwnProperty('changeDetails')) {
			let pane = UI.div(null, ge('updateDetailsTemplate').content.cloneNode(true));

			this._firstName = pane.querySelector('#firstName');
			this._lastName = pane.querySelector('#lastName');
			this._email = pane.querySelector('#email');
			this._username = pane.querySelector('#username');
			this._password = pane.querySelector('#existingPassword1');

			this._panes.changeDetails = pane;
		}

		this._firstName.value = this.firstName;
		this._lastName.value = this.lastName;
		this._email.value = this.email;
		this._username.value = this.username;
		this._password.value = '';

		this.outputPane.appendChild(this._panes.changeDetails);
		state(this.outputPane);
	}

	saveDetails() {
		API.update(
			'accounts',
			{
				firstName: this._firstName.value,
				lastName: this._lastName.value,
				email: this._email.value,
				username: this._username.value,
				password: this._password.value
			}
		)
		.then(data => {
			this.init(data);
		});
		
		this._password.value = '';
	}

	getChangePasswordForm() {
		if (!this._panes.hasOwnProperty('changePassword')) {
			this._panes.changePassword = UI.template('changePasswordTemplate');
			this._newPassword = this._panes.changePassword.querySelector('#newPassword');
			this._password2 = this._panes.changePassword.querySelector('#existingPassword2');
			this.showPass = this._panes.changePassword.querySelector('#showPass');
			onEv(this.showPass, 'change', () => {
				this._newPassword.type = this.showPass.checked ? 'text' : 'password';
			})
		}
		
		this._newPassword.value = '';
		this._password2.value = '';

		this.outputPane.appendChild(this._panes.changePassword);
		state(this.outputPane);
	}
	
	savePassword() {
		API.update(
			'accounts/password',
			{
				newPassword: this._newPassword.value,
				password: this._password2.value
			}
		)
		.then(data => {
			this.init(data);
		});

		this._password2.value = '';
	}

	getDisplaySettingsPane() {
		let prefs = this._displayPrefs;
		let selectedTheme = parseInt(prefs.theme) || 0;
		let selectedFont = parseInt(prefs.font) || 1;
		let selectedFontSize = parseInt(prefs.fontSize) || 3;

		let colorPicker = new ColorPicker2();
		colorPicker.HEX = prefs.bgColor || 'ffffff';
		let hue = colorPicker.h;
		let sat = colorPicker.s * 2;

		// Theme selector
		let themeImages = [];
		let themeNames = ['Default', 'Cool', 'Natural'];

		for (let i = 0; i < AC.THEMES.length; i++) {
			let palette = AC.THEMES[i];
			let swatch = UI.div('w-16 h-16 rounded-lg cursor-pointer border-2 overflow-hidden ' +
				(i === selectedTheme ? 'border-primary-600' : 'border-transparent hover:border-neutral-300'));
			let top = UI.div('h-1/2');
			top.style.backgroundColor = palette.primary[600];
			let bottom = UI.div('h-1/2');
			bottom.style.backgroundColor = palette.secondary[700];
			swatch.append(top, bottom);
			swatch.title = themeNames[i] || ('Theme ' + i);
			onEv(swatch, 'click', () => {
				selectedTheme = i;
				for (let t of themeImages) {
					t.className = 'w-16 h-16 rounded-lg cursor-pointer border-2 overflow-hidden border-transparent hover:border-neutral-300';
				}
				swatch.className = 'w-16 h-16 rounded-lg cursor-pointer border-2 overflow-hidden border-primary-600';
				updatePreview();
			});
			themeImages.push(swatch);
		}

		// Preview
		let previewHead = UI.div('px-3 py-1 text-white text-sm rounded-t', _('TITLE & MENU'));
		let previewBody = UI.div('px-3 py-3 text-sm', 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Adipisci, alias assumenda cupiditate distinctio dolorem earum.');
		let previewFoot = UI.div('px-3 py-1 text-white text-xs rounded-b', _('FOOTER'));
		let preview = UI.div('w-full max-w-xs border border-neutral-300 rounded overflow-hidden', [previewHead, previewBody, previewFoot]);

		// Background color sliders
		let hueHandle = htm('i', 'absolute top-0 bottom-0 w-4 -ml-2 rounded bg-white border border-neutral-400 cursor-pointer');
		let hueSlider = UI.div('relative h-8 rounded cursor-pointer', hueHandle);
		hueSlider.style.background = `linear-gradient(to right,
		hsl(0, 100%, 50%),
		hsl(60, 100%, 50%),
		hsl(120, 100%, 50%),
		hsl(180, 100%, 50%),
		hsl(240, 100%, 50%),
		hsl(300, 100%, 50%),
		hsl(360, 100%, 50%))
		`;

		let satHandle = htm('i', 'absolute top-0 bottom-0 w-4 -ml-2 rounded bg-white border border-neutral-400 cursor-pointer');
		let satSlider = UI.div('relative h-8 rounded cursor-pointer', satHandle);

		// Font selects
		let fontSelect = htm('select', 'ed-text');
		[['1', 'Open Sans'], ['2', 'Roboto'], ['3', 'Junction'], ['4', 'Sylexiad Sans']].forEach(([val, label]) => {
			let opt = htm('option');
			opt.value = val;
			opt.textContent = label;
			if (val == selectedFont) opt.selected = true;
			fontSelect.appendChild(opt);
		});
		onEv(fontSelect, 'change', () => {
			selectedFont = parseInt(fontSelect.value);
			updatePreview();
		});

		let sizeSelect = htm('select', 'ed-text');
		[['1', 'Smallest'], ['2', 'Small'], ['3', 'Default'], ['4', 'Large'], ['5', 'Largest']].forEach(([val, label]) => {
			let opt = htm('option');
			opt.value = val;
			opt.textContent = label;
			if (val == selectedFontSize) opt.selected = true;
			sizeSelect.appendChild(opt);
		});
		onEv(sizeSelect, 'change', () => {
			selectedFontSize = parseInt(sizeSelect.value);
			updatePreview();
		});

		let active = null;

		let updatePreview = () => {
			hueHandle.style.left = hue * hueSlider.offsetWidth + 'px';
			satHandle.style.left = sat * satSlider.offsetWidth + 'px';
			satSlider.style.background = 'linear-gradient(to right, rgb(' + colorPicker.hsv2rgb(hue, 0, 1) + '), rgb(' + colorPicker.hsv2rgb(hue, 0.5, 1) + '))';

			let t = Math.min(selectedTheme, AC.THEMES.length - 1);
			let palette = AC.THEMES[t] || AC.THEMES[0];
			previewHead.style.backgroundColor = palette.primary[600];
			previewFoot.style.backgroundColor = palette.secondary[700];

			let fontSizeVar = 1;
			switch (selectedFont) {
				case 2: previewBody.style.fontFamily = 'Roboto'; break;
				case 3: previewBody.style.fontFamily = 'Junction'; break;
				case 4: previewBody.style.fontFamily = 'SylexiadSans'; fontSizeVar += 0.2; break;
				default: previewBody.style.fontFamily = 'OpenSans';
			}
			switch (selectedFontSize) {
				case 1: fontSizeVar -= 0.2; break;
				case 2: fontSizeVar -= 0.1; break;
				case 4: fontSizeVar += 0.1; break;
				case 5: fontSizeVar += 0.2; break;
			}
			previewBody.style.fontSize = fontSizeVar + 'em';
			previewBody.style.backgroundColor = 'rgb(' + colorPicker.hsv2rgb(hue, 0.5 * sat, 1).join(',') + ')';
		};

		let dragHandler = {
			drag: () => {
				if (active === 'hue') {
					hue = limit(pointInElem(hueSlider).x, 0, hueSlider.offsetWidth) / hueSlider.offsetWidth;
				} else if (active === 'sat') {
					sat = limit(pointInElem(satSlider).x, 0, satSlider.offsetWidth) / satSlider.offsetWidth;
				}
				updatePreview();
			},
			clicked: function() { this.drag(); }
		};

		onEv(hueSlider, 'mousedown touchstart', (ev) => {
			active = 'hue';
			startDrag(ev || window.event, dragHandler);
		});
		onEv(satSlider, 'mousedown touchstart', (ev) => {
			active = 'sat';
			startDrag(ev || window.event, dragHandler);
		});

		let saveBtn = UI.btn('ed-pri-btn', _('SAVE'), {
			'click': () => {
				colorPicker.HSV = [hue * 360, 50 * sat, 100];
				API.update('accounts/displayPrefs', {
					theme: selectedTheme,
					font: selectedFont,
					fontSize: selectedFontSize,
					bgColor: colorPicker.HEX
				}).then(reply => {
					if (!showError(reply)) {
						window.location.reload();
					}
				});
			}
		});

		let pane = UI.div('', [
			UI.htm('h2', 'text-xl mb-4', _('Display Settings')),
			UI.div('mb-4', [
				UI.htm('h3', 'text-sm font-medium mb-2', _('Colour Theme')),
				UI.div('flex gap-3 flex-wrap', themeImages)
			]),
			UI.div('mb-4', [
				UI.htm('h3', 'text-sm font-medium mb-2', _('Preview')),
				preview
			]),
			UI.div('mb-4', [
				UI.htm('h3', 'text-sm font-medium mb-2', _('Background Colour')),
				UI.htm('label', 'text-xs text-neutral-500 mb-1 block', _('Hue')),
				hueSlider,
				UI.htm('label', 'text-xs text-neutral-500 mb-1 block mt-2', _('Saturation')),
				satSlider
			]),
			UI.div('flex gap-4 mb-4', [
				UI.div('basis-1/2', [
					UI.htm('label', 'ed-label', _('Typeface')),
					fontSelect
				]),
				UI.div('basis-1/2', [
					UI.htm('label', 'ed-label', _('Text Size')),
					sizeSelect
				])
			]),
			UI.div('text-end', [
				UI.btn('ed-lte-btn', _('BACK'), {'click': () => this.back()}),
				saveBtn
			])
		]);

		this.outputPane.appendChild(pane);

		// defer preview update until elements are in DOM
		setTimeout(updatePreview, 0);

		state(this.outputPane);
	}

	getSubscriptionTypePane() {
		if (!this._panes.hasOwnProperty('typeOptions')) {
			let pane = UI.div(null, ge('subscriptionTypeTemplate').content.cloneNode(true));
			
			for(let node of pane.querySelectorAll('input[name="radio-freq"]')) {
				node.checked = node.value == this.freq;
			}
			for(let node of pane.querySelectorAll('input[name="subscriptionType"]')){
				node.checked = node.value == this._type;
			}
			this._panes.subscriptionType = pane;
		}
		
		this.outputPane.appendChild(this._panes.subscriptionType);
		this.updateTypePane();
		state(this.outputPane);
	}

	updateTypePane() {
		if (!this._route[0] == 'subscription-type') return;

		this.outputPane.querySelector('#individual-price-a').innerText = '£' +
			(this._freq == SUBSCRIPTION.MONTHLY ?
			this._tariff.im + '/month' : this._tariff.iy + '/year');
		this.outputPane.querySelector('#individual-price-b').innerText = 
			this._freq == SUBSCRIPTION.MONTHLY ?
			'' : ('(£' + (this._tariff.iy / 12).toFixed(2) + '/month)');
		this.outputPane.querySelector('#family-price-a').innerText = '£' +
			(this._freq == SUBSCRIPTION.MONTHLY ?
			this._tariff.fm + '/month' : this._tariff.fy + '/year');
		this.outputPane.querySelector('#family-price-b').innerText = 
			this._freq == SUBSCRIPTION.MONTHLY ?
			'' : ('(£' + (this._tariff.fy / 12).toFixed(2) + '/month)');
	}

	afterType() {
		if (this.paymentValid) 
			this.goto('confirm-subscription');
		else {
			this.goto('payment-form');
		}
	}
	
	async getPaymentForm() {
		state(this.outputPane, "loading");

		if (!this._paymentForm) {
			this._paymentForm = new PaymentForm();
			await this._paymentForm.init(
				this.back.bind(this),
				() => this.goto('billing-address-form'),
				this.afterPaymentForm.bind(this),
				!this.paymentRequired
			);
		}
		
		this.outputPane.appendChild(this._paymentForm.form);
		this._paymentForm.phone.focus();
		this._paymentForm.phone.select();
		state(this.outputPane);
	}
	
	getBillingAddressForm() {
		this.outputPane.appendChild(this._paymentForm.addressForm);
		this._paymentForm.street.focus();
		this._paymentForm.street.select();
		state(this.outputPane);
	}

	afterPaymentForm() {
		if (this._paymentForm.isValid) {
			this.goto('confirm-subscription');
		}
	}

	async getConfirmSubscriptionPane() {
		let data = await API.insert('subscriptions', {
			type: this.type,
			freq: this.freq,
			confirm: false,
			cardEnding: this._paymentForm.cardEnding
		});
		
		if (!this._panes.hasOwnProperty('summary')) {
			this._panes.summary = UI.div(null, ge('summary-template').content.cloneNode(true));
		}
		this._panes.summary.querySelector('#subscription-summary').innerText = data.newDesc;
		this._panes.summary.querySelector('#payment-summary').innerText = data.payment;
		
		let members = this._panes.summary.querySelector('#members-summary');
		members.innerHTML = "";

		if (this._members.length && !this.isFamily) {
			members.appendChild(UI.div(null, [
				htm('h2', null, _("Existing family members")),
				p(null, _("It looks like you're changing from a family membership to individual")),
				p(null, _("Any members other than yourself may have their subscription affected!"))
			]));
		}

		this.outputPane.appendChild(this._panes.summary);
		state(this.outputPane);
	}
	
	confirmSubscription() {
		if (!ge('agree-checkbox').checked) {
			makeToast('Please indicate that you agree to the terms of use');
			return;
		}
		state(this.outputPane, "loading");
		this.saveSubscription();
	}

	saveSubscription() {
		if (this._paymentForm && this._paymentForm.tokenHasExpired) {
			this._paymentForm.refreshToken(this.saveSubscription.bind(this));
			return;
		}

		API.insert('subscriptions', {
			type: this.type,
			freq: this.freq,
			confirm: true,
			paymentMethod: this._paymentForm == null ? null : this._paymentForm.paymentData
		}).then(reply => {
			this.showMembersPane = true;

			if (reply.status && reply.status == "3DAuth") {
				this._paymentForm.threeDAuth(
					reply.cReq,
					reply.opayoTransId,
					reply.acsUrl,
					this.outputPane,
					this.getData.bind(this)
				)
			}
			else {
				if (reply.error) {
					makeToast(reply.error);
				}
				this.getData();
			}
		});
	}
	
	async getMembersPane() {
		this._unchanged = [];
		this._additions = [];
		this._removals = [];

		for (let m of this._members) {
			this._unchanged.push([m.id, m.name]);
		}

		let pane = UI.div(null, ge('membersTemplate').content.cloneNode(true));

		for (let circle of nav.circles.circles) {
			let cb = UI.chk();
			cb.id = circle.center;
			for (let m of this._members) {
				if (m.id === circle.center) {
					cb.checked = true;
					break;
				}
			}
			onEv(cb, 'change', () => this.toggleMember(circle.center, circle.ownerName));
			pane.querySelector('#member-circles').appendChild(
				UI.div(
					'',
					UI.toggle(cb, [UI.span('', circle.ownerName)]),
				)
			);
		}

		this._panes.members = pane;

		this.countMembers();
		this.outputPane.appendChild(this._panes.members);
		state(this.outputPane);
	}
	
	removePayment() {}

	setMembers() {
		API.insert('subscriptions/family-members', {
			additions: this._additions,
			unchanged: this._unchanged,
			removals: this._removals,
		}).then(reply => this.init(reply));
	}

	removePayment() {
		Dialog.Confirm(
			_("If no payment method is available when the subscription is due for renewal service may be disrupted."), 
			_("REMOVE PAYMENT METHOD"),
			() => {
				API.delete('payment-methods').then((_) => {this.getData()});
			}
		)
	}
	
	getToken(merchantSessionKey) {
	}
	
	spaceLeft() {
		return 5 - this._additions.length - this._unchanged.length;
	}
	
	countMembers() {
		this._panes.members.querySelector('#member-counter').innerText = this.spaceLeft();
	}
	
	toggleMember(memberId, name) {
		this.removeMember(memberId, name) || this.addMember(memberId, name);
		this.countMembers();
	}

	addMember(id, name) {
		if (this.spaceLeft < 1) return false;
		for (let i = 0; i < this._removals.length; i++) {
			if (this._removals[i][0] == id) {
				this._unchanged.push(this._removals.splice(i,1)[0]);
				return true;
			}
		}
		for (let m of this._additions) {
			if (m[0] == id) {
				return false;
			}
		}
		this._additions.push([id, name]);
		return true;
	}
	
	removeMember(id) {
		for (let i = 0; i < this._unchanged.length; i++) {
			if (this._unchanged[i][0] == id) {
				this._removals.push(this._unchanged.splice(i, 1)[0]);
				return true;
			}
		}
		for (let i = 0; i < this._additions.length; i++) {
			if (this._additions[i][0] == id) {
				this._additions.splice(i,1);
				return true;
			}
		}
		return false;
	}

	acceptAllocation(id) {
		API.fetch(`allocations/${id}/accept`)
		.then(_ => this.getData());
	}

	declineAllocation(id) {
		API.fetch(`allocations/${id}/reject`)
		.then(_ => this.getData());
	}
	
	getCancelPane () {
		if (!this._panes.hasOwnProperty('cancelPane')) {
			let pane = UI.div(null, ge('cancelSubscriptionTemplate').content.cloneNode(true));
			this._panes.cancelPane = pane;
		}
		this.outputPane.appendChild(this._panes.cancelPane);
		state(this.outputPane);
	}
	
	confirmCancel() {
		API.delete('subscriptions')
		.then(reply => this.init(reply));
	}
}